import { SHARE, PORCENTAGE, GIFT, COINS,
        COIN, MORE, EDIT, CROWN, FRIENDS, PROFILE } from '../constants/images'


const getImageState = icon => {

    if (icon === "share") {
        return SHARE;
    } else if (icon === "porcentage" ) {
        return PORCENTAGE;
    } else if (icon === "gift" ) {
        return GIFT;
    } else if (icon === "coins" ) {
        return COINS;
    } else if (icon === "coin" ) {
        return COIN;
    } else if (icon === "more" ) {
        return MORE;
    } else if (icon === "edit" ) {
        return EDIT;
    } else if (icon === "friend" ) {
        return FRIENDS;
    } else if (icon === "profile" ) {
        return PROFILE;
    } else {
        return CROWN;
    }
}

export default getImageState;
